import React, { Component } from "react";
import { connect } from "react-redux";
import { removeErrorMessage, removeSuccessMessage } from "../core/actions/messaging";

const NOTIFICATION_TYPE_GOOD = 'good';
const NOTIFICATION_TYPE_BAD = 'bad';

class _RegisterMessagesWrapper extends Component {

    constructor(props) {
        super(props)
        this.removeSuccessMessage = this.removeSuccessMessage.bind(this);
        this.removeErrorMessage = this.removeErrorMessage.bind(this);
    }

    removeSuccessMessage(heading) {
        this.props.dispatch( removeSuccessMessage(heading) )
    }

    removeErrorMessage(heading) {
        this.props.dispatch( removeErrorMessage(heading) )
    }

    render() {
        const { successMessages, errorMessages, tableHeaderIsFixed } = this.props;

        return tableHeaderIsFixed ? null : (
            <div>
                { successMessages.map(item => (
                    <RegisterMessage
                        key={ NOTIFICATION_TYPE_GOOD + '.' + item.heading }
                        type={ NOTIFICATION_TYPE_GOOD }
                        heading={ item.heading }
                        content={ item.content }
                        clearMessage={ this.removeSuccessMessage }
                    />
                )) }
                { errorMessages.map(item => (
                    <RegisterMessage
                        key={ NOTIFICATION_TYPE_BAD + '.' + item.heading }
                        type={ NOTIFICATION_TYPE_BAD }
                        heading={ item.heading }
                        content={ item.content }
                        clearMessage={ this.removeErrorMessage }
                    />
                )) }
            </div>
        )
    }
}

export const RegisterMessagesWrapper = connect((state) => ({
    successMessages: state.messages.success,
    errorMessages: state.messages.error,
    tableHeaderIsFixed: state.mutableInterface.tableHeaderIsFixed,
}))(_RegisterMessagesWrapper);


const RegisterMessage = ({ type, heading, content, clearMessage }) => (
    <div className="u-mt--xsmall u-mx--xsmall xmd-block">
        <div className={`u-flex flex--center u-pos-relative u-p--medium u-b--round notification--${type}`}>
            <div className="u-flex flex--center flex--justify-center u-mr--xsmall">
                <svg className="" style={{width: '34px', height: '34px'}}>
                    <use xlinkHref={`#icon-notification-${type}`}></use>
                </svg>
            </div>
            <div className="u-flex-1">
                <h4>{heading}</h4>
                {content}
            </div>
            <button
                // className="u-pos-absolute cursor-pointer u-m-reset u-p--reset button-reset u-top-xsmall u-right-small"
                className="u-pos-absolute cursor-pointer u-m-reset u-p--reset u-top-xsmall u-right-small button-reset"
                onClick={ () => clearMessage(heading) }
            >
                <svg className="icon-close-small" style={{width: '12px', height: '12px'}}>
                    <use xlinkHref="#icon-close-small"></use>
                </svg>
            </button>
        </div>
    </div>
);
